import { MergePatientsModalFooter } from '@/components/MergePatients/MergePatientsModalFooter';
import { MergePatientsModalInfo } from '@/components/MergePatients/MergePatientsModalInfo';
import { Typography } from '@montugroup/design-system';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import { MergeProfileInput, MergeProfileInputType } from './MergeProfileInput';

export type PatientDetails = {
  patientCode: string;
  firstName: string;
  lastName: string;
  email: string;
  dob: string;
  gender: string;
  medicareNumber: string;
  dvaNumber: string;
  address: string;
};

export const emptyPatientDetails: PatientDetails = {
  patientCode: '',
  firstName: '',
  lastName: '',
  email: '',
  dob: '',
  gender: '',
  medicareNumber: '',
  dvaNumber: '',
  address: '',
};

type MergePatientsModalContentProps = {
  onClose: () => void;
  setShowConfirmation: (open: boolean) => void;
  primaryPatientDetails: PatientDetails;
  setPrimaryPatientDetails: (patientDetails: PatientDetails) => void;
  secondaryPatientDetails: PatientDetails;
  setSecondaryPatientDetails: (patientDetails: PatientDetails) => void;
};

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

const MergeProfileInputContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(8),
  marginBottom: theme.spacing(8),
  gap: theme.spacing(4),
}));

const MergeProfileInputWrapper = styled(Box)(() => ({
  flex: 1,
}));

export const MergePatientsModalContent = ({
  onClose,
  setShowConfirmation,
  primaryPatientDetails,
  setPrimaryPatientDetails,
  secondaryPatientDetails,
  setSecondaryPatientDetails,
}: MergePatientsModalContentProps) => {
  const isMergeDisabled: boolean =
    !primaryPatientDetails.patientCode ||
    !secondaryPatientDetails.patientCode ||
    primaryPatientDetails.patientCode === secondaryPatientDetails.patientCode;

  return (
    <>
      <Box>
        <StyledTypography>
          Consultations, prescriptions, and documents on the secondary profile will be{' '}
          <b>merged into the primary profile</b>.
        </StyledTypography>
        <StyledTypography>The secondary profile will be removed.</StyledTypography>
      </Box>
      <MergeProfileInputContainer>
        <MergeProfileInputWrapper>
          <MergeProfileInput
            type={MergeProfileInputType.PRIMARY}
            patientDetails={primaryPatientDetails}
            setPatientDetails={setPrimaryPatientDetails}
          />
        </MergeProfileInputWrapper>
        <Box display={'flex'} flexDirection={'row'} justifyContent={'center'} sx={{ paddingTop: 16 }}>
          <ArrowBackIcon />
          <Typography fontWeight={'bold'}>Merge with</Typography>
        </Box>
        <MergeProfileInputWrapper>
          <MergeProfileInput
            type={MergeProfileInputType.SECONDARY}
            patientDetails={secondaryPatientDetails}
            setPatientDetails={setSecondaryPatientDetails}
          />
        </MergeProfileInputWrapper>
      </MergeProfileInputContainer>
      <MergePatientsModalInfo />
      <MergePatientsModalFooter
        onCancel={onClose}
        onProceed={() => setShowConfirmation(true)}
        isProceedDisabled={isMergeDisabled}
        proceedLabel={'Merge profiles'}
      />
    </>
  );
};
